import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa';

const Contact = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="p-4 shadow-sm text-center">
            <h4 className="mb-3">We'd Love to Hear from You</h4>
            
            <p><strong>Email:</strong> <a href="mailto:shaheena@masterleadership.id">mira@masterleadership.id</a></p>
            <p><strong>Phone:</strong> <a href="tel:+628129341650">+628129341650</a></p>

            <div className="mt-4">
              <strong>Connect with Us:</strong>
              <div className="d-flex justify-content-center gap-4 mt-3">
                <a href="https://www.instagram.com/masterleadershipconsultant/" target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={28} color="#E1306C"/>
                </a>
                <a href="https://www.youtube.com/@shaheenanazir4545" target="_blank" rel="noopener noreferrer">
                  <FaYoutube size={28} color="#FF0000" />
                </a>
                <a href="https://www.linkedin.com/in/shaheena-nazir/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin size={28} color="#0a66c2" />
                </a>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
